module.exports = __webpack_public_path__ + "static/carousel-hero-classic-b85d679c79979be957d7446548c67943.png";